import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/** 안내 화면 공통 버튼: 이전 화면이 있으면 "이전으로", 그리고 서비스 첫 화면으로 */
export function StatusPageActions() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canGoBack = (window.history.state?.idx ?? 0) > 0;

  return (
    <>
      {canGoBack && (
        <button type="button" className="hs-btn" onClick={() => navigate(-1)}>
          <i className="fa-solid fa-arrow-left" />
          {t('hs.go-back')}
        </button>
      )}
      <a className="hs-btn primary" href="/">
        <i className="fa-solid fa-house" />
        {t('hs.go-home')}
      </a>
    </>
  );
}
